import React from 'react';
import { AlertTriangleIcon, CheckIcon, CreditCardIcon, LockIcon, ShieldCheckIcon, ZapIcon } from 'lucide-react';
import { purchaseUrl } from '../data/content';
import { Button } from './ui/Button';
import { Countdown } from './ui/Countdown';
const included = ['5 Módulos completos: Biblioteca de ejercicios, Fase 1 Adaptación, Fase 2 Tonificación, Fase 3 Intensidad y Rutinas express + Continuidad', 'BONO 1 — Recetario Fit Express (gratis)', 'BONO 2 — Dulces Fit Sin Culpa (gratis)', 'BONO 3 — Cocina Simple Para No Abandonar (gratis)', 'Garantía de 7 días sin preguntas', 'Acceso de por vida a actualizaciones'];
type PricingProps = {
  id?: string;
};
export function Pricing({
  id = 'pricing'
}: PricingProps) {
  const titleId = `${id}-title`;
  return <section id={id} className="scroll-mt-24 bg-canvas px-4 py-14 md:py-16" aria-labelledby={titleId} data-id="element-212" data-mp="2r1lqbztvdh9u">
      <div className="mx-auto max-w-2xl text-center" data-id="element-213" data-mp="2v408ehppsd02">
        <p className="text-[11px] font-extrabold uppercase tracking-[.16em] text-primary md:text-sm" data-id="element-214" data-mp="2v0m7zf0m2dv9">
          ⏰ Precio de lanzamiento — cierra en:
        </p>
        <div className="mt-4" data-id="element-215" data-mp="2apsyc0ynurdu">
          <Countdown data-id="element-216" data-mp="2aqucwfevxw0b" />
        </div>
        <p className="mt-4 inline-flex items-center gap-2 rounded-full border border-red-200 bg-red-50 px-4 py-2 text-xs font-extrabold text-red-600" data-id="element-217" data-mp="2oosgqqvkya1k">
          <AlertTriangleIcon className="h-4 w-4" data-id="element-218" data-mp="2korzyzl0dmrc" />
          Después sube $5.000 ARS. No vuelve.
        </p>

        <article className="mt-8 rounded-3xl border-4 border-primary bg-white p-6 text-left shadow-[0_24px_60px_rgba(226,85,44,.18)] md:p-9" data-id="element-219" data-mp="2yk3tj3nfh76o">
          <div className="text-center" data-id="element-220" data-mp="38cjd25edi3to">
            <span className="inline-flex rounded-full bg-primary px-4 py-1.5 text-[11px] font-extrabold uppercase tracking-wide text-white" data-id="element-221" data-mp="38bgpo7g9ejii">
              🔥 Precio especial de lanzamiento
            </span>
            <h2 id={titleId} className="mt-4 text-xl font-black text-ink md:text-3xl" data-id="element-222" data-mp="3havdt08yehzu">
              Acceso a los 5 módulos + 3 bonos GRATIS
            </h2>
          </div>

          <ul className="my-7 space-y-2.5 border-y border-line py-6" data-id="element-223" data-mp="2a2091m2c77uw">
            {included.map(item => <li key={item} className="flex items-start gap-2 text-sm font-semibold text-ink/80" data-id="element-224" data-mp="2ezrz0ajf8jwg">
                <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-primary" data-id="element-225" data-mp="2izu5cx03q1i2" />
                {item}
              </li>)}
          </ul>

          <div className="text-center" data-id="element-226" data-mp="2srgd2jd8dig2">
            <p className="text-base font-bold text-ink/40 line-through" data-id="element-227" data-mp="2sqexc1l9s7s0">
              Valor regular: $87.990 ARS
            </p>
            <p className="text-[11px] font-extrabold uppercase tracking-wide text-ink/60" data-id="element-228" data-mp="2xrumo5uhd0g7">
              Hoy (precio de lanzamiento)
            </p>
            <p className="text-4xl font-black text-primary md:text-6xl" data-id="element-229" data-mp="36pog990v1fzo">💰 $19.990</p>
            <div className="mt-6" data-id="element-230" data-mp="18bv7o846kgsn">
              <Button href={purchaseUrl} fullWidth className="text-sm md:text-lg" data-id="element-231" data-mp="18cwhk99gmx8s">
                🎯 QUIERO MI PROGRAMA AHORA →
              </Button>
            </div>
            <div className="mt-5 flex flex-wrap items-center justify-center gap-x-4 gap-y-2 text-[11px] font-semibold text-ink/60" data-id="element-232" data-mp="14u7gmfqz9ol6">
              <span className="flex items-center gap-1" data-id="element-233" data-mp="1014lw4ags93e">
                <LockIcon className="h-3.5 w-3.5 text-primary" data-id="element-234" data-mp="v2kys0k4wr9g" /> Pago 100% seguro
              </span>
              <span className="flex items-center gap-1" data-id="element-235" data-mp="r2k9fkvhyvnm">
                <ZapIcon className="h-3.5 w-3.5 text-primary" data-id="element-236" data-mp="qzy1hk4p2e4v" /> Acceso en 5 minutos
              </span>
              <span className="flex items-center gap-1" data-id="element-237" data-mp="1isxehxlmfsal">
                <ShieldCheckIcon className="h-3.5 w-3.5 text-primary" data-id="element-238" data-mp="1itgkqh1wss8s" /> Garantía 7 días
              </span>
              <span className="flex items-center gap-1" data-id="element-239" data-mp="1epsf43wu86q6">
                <CreditCardIcon className="h-3.5 w-3.5 text-primary" data-id="element-240" data-mp="19ss91szzn3z2" /> Mercado Pago · Tarjeta ·
                Transferencia
              </span>
            </div>
          </div>
        </article>
      </div>
    </section>;
}